import {Injectable, Injector} from '@angular/core';
import {BehaviorSubject, Observable, of, ReplaySubject} from 'rxjs';
import {AuthService} from 'src/app/shared/services/auth.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {brands, fibraSpeeds, mobileContractType, orderType, technologyTypes, typeCard, brandPortability} from '../../shared/constantes';
import {descuento, SimyoGlobals, terminalStatus} from '../classes/simyo-globals';
import {SimyoRateService} from './simyo-rate.service';
import {masterAllResponseSimyo, masterAllSimyo} from '../models/masterAllSimyo';
import {uploadFileResponse} from 'src/app/shared/models/uploadFileResponse';
import {orderListRequest, orderListResponseSimyo, orderListStatsResponseSimyo} from '../models/orderListSimyo';
import { responseReuseIVAccessSimyo, reuseIVAccessSimyo } from '../models/installationVirtual';
import { concatMap, defaultIfEmpty, map, tap } from 'rxjs/operators';
import { PermissionService } from 'src/app/shared/services/permission.service';
import { SimyoOrderService } from './simyo-order.service';
import { SimyoStepperService } from './simyo-stepper.service';
import { SimyoShoppingCartService } from './simyo-shopping-cart.service';

@Injectable({
    providedIn: 'root'
})
export class SimyoService {

    // Masters
    private provincesCommun: any;
    private roadTypesCommun: any;
    private masterAll: BehaviorSubject<masterAllSimyo>;

    // Order
    private typeOrder: any;
    private rateFtth: any;
    private rateFtthObservable: any;
    private bonusObservable: any;
    private rateMobiles: any[];
    private rateMobileObservable: any;
    private mobilePacks: any[];
    private mobilePacksObservable: any;
    private preventDestroyObservable: any;
    private swapSim: any;

    private userData: any;
    private formsData: any;
    private coberturaData: any;
    private normalizadorData: any;
    private resultadosCustomer: any;
    private resultadosNotCustomer: any;
    private customerPromotion: any;

    private indexToRemove: BehaviorSubject<boolean>;

    private changeMobilePack: boolean;
    private isChanging = false;
    private nebaNoCommercial = false;
    private zip_code = '';
    private taxType = '';
    private isChangeRate = false;

    private virtualInstallationData: reuseIVAccessSimyo = {
        brand: brands.simyo,
        customerName: null,
        documentNumber: null,
        documentType: null,
        gescal37: null,
        footprint: technologyTypes.dir
    };

    private canVirtualInstallation: boolean = false;
    private responseReuseIVAccess: responseReuseIVAccessSimyo = null;

    public customerInfo: any = null;
    private allRates: any = null;
    private simyoOrderService: SimyoOrderService;
    public customerData: any = null;

    /**
    * Digimovil: 18
    * Aire Networks: 49
    * Avatel: 815
    * Fi Network: 48
    * Lowi - Vodafone Enabler: 47
    * PTV TELECOM 4G: 109
    * PTV TELECOM 5G: 2547
    * Vodafone: 2
    * Vodafone Roaming: 353
    */
    public excludeProviders = [18, 49, 815, 109, 2547];


    private selectedOperator;
    private changeRateCart = false;
    private isNewProcessing = false;

    public isPortaOperationSelectedInModal: boolean = false;

    constructor(
        private http: HttpClient,
        private auth: AuthService,
        private rateService: SimyoRateService,
        public simyoGlobals: SimyoGlobals,
        public permissionService: PermissionService,
        private injector: Injector,
        private simyoStepperService: SimyoStepperService,
        private shoppingCartService: SimyoShoppingCartService
    ) {
        this.rateMobiles = [];
        this.mobilePacks = [];
        this.typeOrder = new BehaviorSubject<string>('convergent');
        this.rateFtthObservable = new BehaviorSubject<any>(null);
        this.bonusObservable = new BehaviorSubject<any>([]);
        this.rateMobileObservable = new BehaviorSubject<any>([]);
        this.mobilePacksObservable = new BehaviorSubject<any>([]);
        this.preventDestroyObservable = new BehaviorSubject(false);
        this.userData = new BehaviorSubject<any>(null);
        this.formsData = new BehaviorSubject<any>(null);
        this.coberturaData = new BehaviorSubject<any>(null);
        this.normalizadorData = new BehaviorSubject<any>(null);
        this.indexToRemove = new BehaviorSubject<any>(null);
        this.resultadosCustomer = new BehaviorSubject<any>(null);
        this.resultadosNotCustomer = new BehaviorSubject<any>(null);
        this.customerPromotion = new BehaviorSubject<any>(null);
        this.swapSim = new BehaviorSubject<any>(null);
        this.changeMobilePack = true;

        this.selectedOperator = new ReplaySubject<any>(1);


        // Masters
        this.provincesCommun = new BehaviorSubject(null);
        this.roadTypesCommun = new BehaviorSubject(null);
        this.masterAll = new BehaviorSubject<masterAllSimyo>(null);

        this.rateService.getRates().subscribe(data => {
            if(data) {
                this.allRates = data;
            }
        });

        this.getCustomerData().subscribe();
    }

    // Masters service
    getProvincesCommunFromService() {
        return this.http.get(environment.comunEndpoint + 'coverage/provinces', {headers: this.getHeaders()});
    }

    getRoadTypeCommunFromService() {
        return this.http.get(environment.comunEndpoint + 'coverage/road-types', {headers: this.getHeaders()});
    }

    getCustomerInfoFromService(customerInfo) {
        let body = {...customerInfo, permissions: this.permissionService.getPermissionSimyoRates()};
        return this.http.post(environment.simyoEndPoint + 'customer/info', body, {headers: this.getHeaders()}).pipe(

            tap((response:any) => {
                if (response.msg) {
                    this.customerInfo = response.msg;
                    return
                }
                this.customerInfo = null;
            })
        );
    }

    getTerminals() {
        return this.http.get(environment.simyoEndPoint + 'terminals', {headers: this.getHeaders()});
    }

    public getContract(order_id: number): Observable<any> {
        return this.http.get(environment.simyoEndPoint + 'order/' + order_id + '/document/contract/download', {headers: this.getHeadersPdf(), responseType: 'blob'});
    }

    public getSepa(order_id) {
        return this.http.get(environment.simyoEndPoint + 'order/' + order_id + '/document/sepa/download', {headers: this.getHeadersPdf(), responseType: 'blob'});
    }

    public getFileUpload(order_id, assetId) {
        return this.http.get(environment.simyoEndPoint + 'order/' + order_id + '/document/' + assetId + '/download', {headers: this.getHeadersPdf(), responseType: 'blob'});
    }

    public getFilteredOrderList(filters: orderListRequest): Observable<orderListResponseSimyo> {
        return this.http.post<orderListResponseSimyo>(environment.simyoEndPoint + 'order/list/filter', filters, {headers: this.getHeaders()}).pipe(
            map((data:orderListResponseSimyo) => {
                if (data && data.msg && data.msg.data) {
                    let orders = data.msg.data.map(order =>{
                        if (order.mobiles) {
                            return {...order, mobiles: order.mobiles.map(mobile => {return {...mobile, is_esim: mobile.is_esim ? typeCard.esim : typeCard.sim}})};
                        }
                        else {
                            return order;
                        }
                    });
                    data.msg.data = orders;
                }
                return data;
            })
        );
    }

    public getFilterAlerts(filters: string): Observable<orderListResponseSimyo> {
        return this.http.get<orderListResponseSimyo>(environment.simyoEndPoint + 'order/list/alerts' + filters, {headers: this.getHeaders()});
    }

    public getOrderListStats(): Observable<orderListStatsResponseSimyo> {
        return this.http.post<orderListStatsResponseSimyo>(environment.simyoEndPoint + 'order/list/stats', null, {headers: this.getHeaders()});
    }

    public updateAnnotation(order_id: number, annotation: string): Observable<any> {
        return this.http.patch<any>(environment.simyoEndPoint + 'order/' + order_id + '/annotation', {annotation}, {headers: this.getHeaders()});
    }

    getMasterAllFromService(): Observable<masterAllResponseSimyo> {
        return this.http.get<masterAllResponseSimyo>(environment.simyoEndPoint + 'master/all', {headers: this.getHeaders()});
    }

    public uploadFile(file: File, orderId: number, documentUploadType?: string, documentUploadId?: number): Observable<uploadFileResponse> {
        const formData = new FormData();
        const header = new HttpHeaders({
            Authorization: 'Bearer ' + this.auth.getToken()
        });

        formData.append('document', file);
        if (documentUploadType && documentUploadType !== '') {
            formData.append('document_upload_type', documentUploadType);
        }
        if (Number.isInteger(documentUploadId)) {
            formData.append('document_upload_id', documentUploadId.toString());
        }
        return this.http.post<uploadFileResponse>(environment.simyoEndPoint + 'order/' + orderId + '/document/upload', formData, {headers: header});
    }

    public uploadFileMultiple(files: File[], orderId: number, documentUploadType?: string, documentUploadId?: number): Observable<uploadFileResponse> {
        const formData = new FormData();
        const header = new HttpHeaders({
            Authorization: 'Bearer ' + this.auth.getToken()
        });

        Array.from(files).forEach((file, index) => {
            formData.append('document' + index, file, file.name);
        });
        if (documentUploadType && documentUploadType !== '') {
            formData.append('document_upload_type', documentUploadType);
        }
        if (Number.isInteger(documentUploadId)) {
            formData.append('document_upload_id', documentUploadId.toString());
        }
        return this.http.post<uploadFileResponse>(environment.simyoEndPoint + 'order/' + orderId + '/document/upload-multiple', formData, {headers: header});
    }

    public uploadFileContract(files: File[], orderId: number, documentUploadId?: any): Observable<uploadFileResponse> {
        const formData = new FormData();
        const header = new HttpHeaders({
            Authorization: 'Bearer ' + this.auth.getToken()
        });

        Array.from(files).forEach((file, index) => {
            formData.append('document' + index, file, file.name);
        });
        if (documentUploadId ?? false) {
            formData.append('document_upload_id', documentUploadId);
        }
        return this.http.post<uploadFileResponse>(environment.simyoEndPoint + 'order/' + orderId + '/document/upload-contract', formData, {headers: header});
    }

    removeOrder(id_remove) {
        const url = environment.simyoEndPoint + 'order/' + `${id_remove}` + '/delete';
        return this.http.delete(url, {headers: this.getHeaders()});
    }

    iccidValidator(number) {
        return this.http.post(environment.simyoEndPoint + 'iccid/validator', {iccid: number}, {headers: this.getHeaders()});
    }

    iccidAvailable(number) {
        return this.http.post(environment.simyoEndPoint + 'iccid/available', {iccid: number}, {headers: this.getHeaders()});
    }

    // Master observers
    setProvincesCommun(data) {
        this.provincesCommun.next(data);
    }

    getProvincesCommun() {
        return this.provincesCommun.asObservable();
    }

    setRoadTypesCommun(data) {
        this.roadTypesCommun.next(data);
    }

    getRoadTypesCommun() {
        return this.roadTypesCommun.asObservable();
    }

    setMasterAll(data: masterAllSimyo) {
        this.masterAll.next(data);
    }

    getMasterAll(): Observable<masterAllSimyo> {
        return this.masterAll.asObservable();
    }

    // Customer
    setDataFromCustomer(data) {
        this.resultadosCustomer.next(data);
    }

    getDataFromCustomer() {
        return this.resultadosCustomer.asObservable();
    }

    setDataFromNotCustomer(data) {
        this.resultadosNotCustomer.next(data);
    }

    getDataFromNotCustomer() {
        return this.resultadosNotCustomer.asObservable();
    }

    setCustomerPromotion(data) {
        if (data) {
            this.customerPromotion.has_ftth = data.has_ftth;
            this.customerPromotion.has_mobile_promotion = data.has_mobile_promotion;
        }
        this.customerPromotion.next(data);
    }

    getCustomerPromotion() {
        return this.customerPromotion.asObservable();
    }

    // Tipo de orden
    setTypeOrder(data) {
        this.typeOrder.next(data);
        this.getSimyoOrderService().setTypeOrder(data);
    }

    getTypeOrder() {
        return this.typeOrder.asObservable();
    }

    setBonus(data: any[]){
        this.bonusObservable.next(data);
    }

    getBonus(){
        return this.bonusObservable.asObservable();
    }


    // Servicios auxiliares
    // Tarifa Fibra
    setRateFtth(data) {
        this.rateFtth = data;
        if(data) {
            let typeRate = Object.keys(data).find(key => data[key]?.rate_id && data[key].rate_id === data.rate_id && key != 'rate_info');
            if(data && data.type_normal && (typeRate === 'type_discount' ? data.type_discount : true)) {
                this.rateFtth.front_discount = typeRate === 'type_discount' ? (+data.type_normal.price - +data.type_discount.price) : 0;
                this.rateFtth.front_total_without_discount = data.type_normal.price;
                this.rateFtth.front_type_discount = typeRate === 'type_discount' ? (this.customerInfo?.has_package ? 'additional_package' : 'first_package') : null; //null|first_package|additional_package
            }
        }
        this.rateFtthObservable.next(this.rateFtth);
    }

    getRateFtth() {
        return this.rateFtthObservable.asObservable();
    }

    setIsChanging(changing) {
        this.isChanging = changing;
    }

    getIsChanging() {
        return this.isChanging;
    }

    // Tarifa(s) móvil(es)
    setRatesMobile(index, value, order?) {
        if (typeof this.rateMobiles[index] === 'undefined') {
            this.rateMobiles.push(value);
        } else {
            this.rateMobiles[index] = value;
        }

        this.rateMobiles = this.calculateMainLine(this.rateMobiles);
        this.rateMobileObservable.next(this.rateMobiles);
    }

    setNewRatesMobile() {
        this.rateMobiles = [];
    }

    setTypePayRatesMobile(index, value) {
        if (this.rateMobiles && this.rateMobiles.length && this.rateMobiles[index]) {
            this.rateMobiles[index].type_pay = value;
            this.rateMobiles = this.calculateMainLine(this.rateMobiles);
            this.rateMobileObservable.next(this.rateMobiles);
        }
    }

    setTerminal(index, value) {
        if (typeof this.rateMobiles[index] !== 'undefined') {
            this.rateMobiles[index].terminal = value;
            this.rateMobiles = this.calculateMainLine(this.rateMobiles);
            this.rateMobileObservable.next(this.rateMobiles);
        }
    }

    removeTerminal(index) {
        if (typeof this.rateMobiles[index] !== 'undefined') {
            this.rateMobiles[index].terminal = null;
            this.rateMobiles = this.calculateMainLine(this.rateMobiles);
            this.rateMobileObservable.next(this.rateMobiles);
        }
    }

    addFirstRatesMobile(value) {
        this.rateMobiles = [];
        this.rateMobiles.unshift(value);
        this.rateMobiles = this.calculateMainLine(this.rateMobiles);
        this.rateMobileObservable.next(this.rateMobiles);
    }

    removeFirstRatesMobile() {
        if (this.rateMobiles.length > 0) {
            this.rateMobiles.shift();
            this.rateMobiles = this.calculateMainLine(this.rateMobiles);
            this.rateMobileObservable.next(this.rateMobiles);
        }
    }

    getRatesMobile() {
        return this.rateMobileObservable.asObservable();
    }

    setChangeMobilePack(mobilePack: boolean){
        this.changeMobilePack = mobilePack;
    }

    getChangeMobilePack(){
        return this.changeMobilePack;
    }

    setMobilePacks(index, value) {
        //this.setChangeMobilePack(false);
        if (typeof this.mobilePacks[index] === 'undefined') {
            this.mobilePacks.push(value);
        } else {
            // Preservar el type_operation original si ya existe
            const existingMobilePack = this.mobilePacks[index];
            if (existingMobilePack && existingMobilePack.type_operation && value.type_operation !== existingMobilePack.type_operation) {
                value.type_operation = existingMobilePack.type_operation;
            }
            this.mobilePacks[index] = value;
        }
        this.mobilePacksObservable.next(this.mobilePacks);
    }

    getMobilePacks() {
        return this.mobilePacksObservable.asObservable();
    }

    getMobilePacksObject() {
        return this.mobilePacks;
    }

    removeLine(index) {
        this.rateMobiles.splice(index, 1);
        this.rateMobiles = this.calculateMainLine(this.rateMobiles)
        this.rateMobileObservable.next(this.rateMobiles);
        this.mobilePacks.splice(index, 1);
        this.mobilePacksObservable.next(this.mobilePacks);
    }

    getIndexToRemove() {
        return this.indexToRemove.asObservable();
    }

    setIndexToRemove(index) {
        this.indexToRemove.next(index);
        setTimeout(() => this.indexToRemove.next(null));
    }

    // AUX
    getPreventDestroy() {
        return this.preventDestroyObservable.asObservable();
    }

    setPreventDestroy(data: boolean) {
        this.preventDestroyObservable.next(data);
    }

    // RESET
    resetMobile() {
        this.rateMobiles = [];
        this.mobilePacks = [];
        this.rateMobileObservable.next(this.rateMobiles);
        this.mobilePacksObservable.next(this.mobilePacks);
    }

    // Iniciar nueva tramitación desde otra
    setUserData(data) {
        this.userData.next(data);
    }

    getUserData() {
        return this.userData.asObservable();
    }

    setFormsData(data) {
        this.formsData.next(data);
    }

    getFormsData() {
        return this.formsData.asObservable();
    }

    setCoberturaData(data) {
        this.coberturaData.next(data);
    }

    getCoberturaData() {
        return this.coberturaData.asObservable();
    }

    setNormalizadorData(data) {
        this.normalizadorData.next(data);
    }

    getNormalizadorData() {
        return this.normalizadorData.asObservable();
    }

    setSwapSim(data) {
        this.swapSim.next(data);
    }

    getSwapSim() {
        return this.swapSim.asObservable();
    }

    isAllowDiscount(mobiles?, type?, speed?, customerData?): boolean {
        let discount = false;
        const typeOrder = type ? type : this.typeOrder.value;
        const customerPromotion = customerData ? customerData : this.customerPromotion.value;
        mobiles = mobiles ? mobiles : this.rateMobiles;
        let minimumPrice = 7; //speed == fibraSpeeds.speed_100 ? 10 : 7;
        if (typeOrder === orderType.CONVERGENT) {
            discount = false;
            if ((this.getShowFtthReduced()) && this.canPackage(mobiles, minimumPrice)) {
                discount = true;
            }
            if ((this.getShowFtthReduced()) && this.getMainLine()) {
                discount = true;
            }
            mobiles.forEach(mobile => {
                if (this.getShowFtthReduced() && mobile.contract_type === 'postpaid') {
                    discount = true;
                }
            });
        }
        if (typeOrder === orderType.BROADBAND && speed) {
            if (customerPromotion) {
                let mainLineMatrix = this.searchMainLineInMatrix(this.getMainLineWithoutSpeed());
                discount = this.getShowFtthReduced() && mainLineMatrix?.rate_info.available_in.includes(`ftth_${speed}`);
            }
        }
        if (typeOrder === orderType.MOBILE) {
            if (customerPromotion && mobiles && mobiles.length) {
                const filterRatesMobile = this.isNumBroadbandMoreThanMobile(customerPromotion.num_ftth, customerPromotion.num_mobile.gt7);

                if (filterRatesMobile) {
                    mobiles.forEach((mobile, index) => {
                        let priceBonos = 0;
                        /*if (mobile.movil) {
                            priceBonos = this.simyoGlobals.pricesBonos(mobile.bonos);
                        } else if (mobile.rate?.rate_info) {
                            mobile.bonos.forEach(x => {
                                priceBonos += +x.rate.rate_info.price;
                            });
                        } else {
                            priceBonos = this.simyoGlobals.pricesBonos(mobile.rate?.bonos);
                        }*/

                        let rateInfo = this.simyoGlobals.findByKeyInMobile(mobile, 'rate_info');
                        // Discount que muestra el mensaje cuando es solo movil que tienen un descuento por paquete con fibra existente
                        if (rateInfo && index === 0 && ((+rateInfo.price + priceBonos) >= descuento)/* && availableMobileDiscount > 0*/) {
                            //mobile.discount = true;
                            discount = true;
                            // availableMobileDiscount--;
                        } else {
                            //if (mobile)
                            //mobile.discount = false;
                        }
                    });
                }
            }
        }
        return discount;
    }

    canPackage(mobiles, minimumPrice = 7){
        mobiles.forEach(movil => {
            if (movil?.contract_type === 'postpaid' && +movil?.rate_info?.price >= minimumPrice) {
                return true;
            }
        });
        return false;
    }

    moreMobileThanBroadband(speed){
        const customerData = this.customerPromotion.value;

        if (!customerData) {
            return false;
        }

        return this.isNumMobileMoreThanBroadband(customerData.num_ftth, customerData.num_mobile, speed);
    }

    terminalsAreValid(order) {
        this.getTerminals()
            .subscribe((data: any) => {
                if (data && data.msg) {
                    order.mobiles.forEach((movil) => {
                        if (movil.terminal_oid) {
                            const found = data.msg.find(terminal => {
                                const optionsTerminal = terminal.terminal_oids.filter((terminalConf: any) => {
                                    let typeOperation, typePay, terminaOid;
                                    typeOperation = terminalConf.portability === movil.portability;
                                    typePay = terminalConf.pay_type === movil.contract_type;
                                    terminaOid = movil.terminal_oid_id === terminalConf.terminal_oid_id;
                                    return typeOperation && typePay && terminaOid && terminal.state === terminalStatus.AVAILABLE;
                                });
                                if (optionsTerminal && optionsTerminal.length) {
                                    return true;
                                }
                            });
                            if (found) {
                                movil.isValidTerminal = true;
                                movil.terminal_oid.terminal.terminal_oids = found.terminal_oids;
                            } else {
                                movil.isValidTerminal = false;
                            }
                        }
                    });
                }
            }, () => {
                order.mobiles.forEach((movil) => {
                    if (movil.terminal_oid) {
                        movil.isValidTerminal = false;
                    }
                });
            });
    }

    /*showDiscountForAdditional(customerData, type, speed?): boolean {
        var ftth = customerData?.num_ftth;
        var total_ftth = (ftth?.ftth_100 + ftth?.ftth_300 + ftth?.ftth_500 + ftth?.ftth_600 + ftth?.ftth_1);
        var total_ftth_discount = (ftth?.ftth_100_discount + ftth?.ftth_300_discount + ftth?.ftth_500_discount + ftth?.ftth_600_discount + ftth?.ftth_1_discount);
        var total_mobile = customerData?.num_mobile?.gt7;

        if (!customerData || !speed) {
            return false;
        }

        if (type === orderType.CONVERGENT || type === orderType.BROADBAND) {

            *if(speed && speed == fibraSpeeds.speed_100) {
                return (total_mobile > total_ftth && customerData?.num_mobile?.gt10 > 0);
            }*
            return (total_mobile > total_ftth);
        }

        if (type === orderType.MOBILE) {

            if (total_ftth > 0 && total_ftth_discount > 0 && (total_ftth - total_ftth_discount == 0)) {
                return true;
            }

        }
        *if (type === orderType.CONVERGENT && customerData && (customerData.num_ftth - customerData.num_mobile) < 0) {
            return true;
        }*
        return false;
    }*/

    setTaxType(zipcode){
        this.zip_code = zipcode + '';
        if (this.zip_code && this.zip_code != '') {
            var tax = this.zip_code.slice(0,2);
                if (tax === '35' || tax === '38') {
                    this.taxType = 'igic';
                    return 'igic';
                }
                if (tax === '51') {
                    this.taxType = 'ipsi_10';
                    return 'ipsi_10';
                }
                if (tax === '52') {
                    this.taxType = 'ipsi_8';
                    return 'ipsi_8';
                }
        }
        this.taxType = 'iva';
        return 'iva';
    }

    getTaxType(){
        return this.taxType;
    }

    getZipCode(){
        return this.zip_code;
    }

    getNebaNoCommercial() {
        return this.nebaNoCommercial; // TODO revisar
    }

    setNebaNoCommercial(neba) {
        this.nebaNoCommercial = neba;
    }

    private getHeaders(): HttpHeaders {
        return new HttpHeaders({
            Authorization: 'Bearer ' + this.auth.getToken(),
            'Content-Type': 'application/json'
        });
    }

    private getHeadersPdf(): HttpHeaders {
        return new HttpHeaders({
            Authorization: 'Bearer ' + this.auth.getToken(),
            Accept: 'application/pdf'
        });
    }

    queryEsimQR(customer_id, msisdn) {
        return this.http.post(environment.simyoEndPoint + 'order/queryEsimQR', {customer_id, msisdn}, {headers: this.getHeaders()});
    }

    sendEsimQR(body) {
        return this.http.post(environment.simyoEndPoint + 'order/sendEsimQR', body, {headers: this.getHeaders()});
    }
    public setVirtualInstallationData(value) {
        this.virtualInstallationData = {...this.virtualInstallationData ,...value};
    }

    public getVirtualInstallationData() {
        return this.virtualInstallationData;
    }

    public setResponseVirtualInstallationData(value) {
        this.responseReuseIVAccess = {...this.responseReuseIVAccess ,...value};
    }

    public getResponseVirtualInstallationData() {
        return this.responseReuseIVAccess;
    }

    public clearVirtualInstallationData() {
        this.responseReuseIVAccess = null;
        this.virtualInstallationData = {
            brand: brands.simyo,
            customerName: null,
            documentNumber: null,
            documentType: null,
            gescal37: null,
        };
        this.setCanVirtualInstallation(false);
    }

    setCanVirtualInstallation(value) {
        this.canVirtualInstallation = value;
    }

    getCanVirtualInstallation() {
        return this.canVirtualInstallation;
    }

    public postVirtualInstallationData(): Observable<responseReuseIVAccessSimyo> {
        return this.http.post(`${environment.simyoEndPoint}order/reuseIVAccess`, this.virtualInstallationData, {headers: this.getHeaders()});
    }

    public postConfirmVirtualInstallation(value): Observable<responseReuseIVAccessSimyo> {
        return this.http.post(`${environment.simyoEndPoint}order/confirmIVAccess`, {registerId: this.responseReuseIVAccess.registerId, ivFrontal: value}, {headers: this.getHeaders()});
    }

    searchPdVByUsername(username) {
        return this.http.post(environment.comunEndpoint + 'digo/user/info', {username}, {headers: this.getHeaders()});
    }

    isNumMobileMoreThanBroadband(num_ftth, mobiles, speed) {
        let sumFtth = num_ftth.ftth_100
                + num_ftth.ftth_300
                + num_ftth.ftth_500
                + num_ftth.ftth_600
                + num_ftth.ftth_1;
        let freeMobiles = mobiles.gt7 - sumFtth;
        /*if(speed == fibraSpeeds.speed_100 && freeMobiles > 0) {
            return mobiles.gt10 > 0;
        }*/
        return freeMobiles > 0;
    }

    isNumBroadbandMoreThanMobile(num_ftth, numMobiles) {
        let sumFtth = num_ftth.ftth_100
                + num_ftth.ftth_300
                + num_ftth.ftth_500
                + num_ftth.ftth_600
                + num_ftth.ftth_1;
        return sumFtth > numMobiles;
    }

    getCustomer() {
        return this.customerInfo ?? null;
    }

    getNotCustomer() {
        return this.customerData ?? null;
    }

    getMaxMobileCustomer() {
        return this.customerInfo ? this.customerInfo.max_mobile : null;
    }

    customerHasPackage() {
        if(this.customerInfo) {
            return this.customerInfo.has_package;
        }

        if(this.customerData) {
            return false;
        }

        return this.getMainLine() !== null;
    }

    customerHasPackageOrMainLine() {
        if(this.customerInfo) {
            if(this.customerInfo.has_package) {
                return true;
            }
        }

        return this.getMainLine() !== null;
    }

    getShowFtthReduced() {
        if(this.getMainLine() !== null || this.getMainLineWithoutSpeed() !== null) {
            if(this.getCustomer() == null) {
                return true;
            }
            let totalFtth = this.getCustomer().num_ftth.total_ftth_discount ?? 0;
            if(totalFtth == 3 && (this.getSimyoOrderService().getIsPortabilityOtherBrand() && this.getSimyoOrderService().getCpOtherBrand() == '12')){
                return true;
            }
            return totalFtth < 3;
        }
        return false;
    }

    getMaxBroadbandCustomer() {
        return this.customerInfo ? this.customerInfo.max_broadband : null;
    }

    getMobileMaxPriceCurrentOrder(onlyCustomer = false) {
        let maxSpeedFtth = this.getMaxFtthSpeed();
        let allowed50GB = this.allowedRate50GBNormalPrice(onlyCustomer);
        return this.rateMobiles.reduce((max, mobile, index) => {
            let currentMobilePrice = (mobile.rate_info.old_price != null && mobile.rate_info.old_price != '') ? +mobile.rate_info.old_price : +mobile.rate_info.price;
            let maxMobilePrice = max != null && max.mobile !== null ? ((max.mobile.rate_info.old_price != null && max.mobile.rate_info.old_price != '') ? +max.mobile.rate_info.old_price : +max.mobile.rate_info.price) : 0;

            let rateNoAdditional = mobile;

            if(mobile?.rate_ids.refered !== '' ) {
                let rates =  this.rateService.determineRates(this.allRates);
                rateNoAdditional = rates.MOBILE.find(rateMobile => (rateMobile.rate_ids.postpaid == mobile?.rate_ids.refered || rateMobile.rate_ids.postpaid == mobile?.rate_ids.postpaid)
                    //|| (rateMobile.rate_ids.prepaid == mobile?.rate_ids.refered || rateMobile.rate_ids.prepaid == mobile?.rate_ids.prepaid)
                );
            }
            if (mobile?.contract_type === mobileContractType.prepaid
                || mobile?.type_pay === mobileContractType.prepaid
                || (mobile?.contract_type === mobileContractType.postpaid && ((allowed50GB && rateNoAdditional?.data == '50 GB' && rateNoAdditional?.voice == 'ILIMITADOS' && JSON.parse(rateNoAdditional.show_in).special_first_line == false) == false && rateNoAdditional?.rate_info.available_in.includes(`ftth_${maxSpeedFtth}`) == false))
            ) {
                return max;
            }
            if (currentMobilePrice > maxMobilePrice) {
                 return {mobile: (rateNoAdditional != null ? rateNoAdditional : mobile), index, beforeMobile: max};
            }
            return {...max, beforeMobile: mobile};
        }, {mobile: null, index: -1, beforeMobile: null});
    }

    /*
    * Funcion para saber si la linea principal esta entre las nuevas en el carrito
    */
    calculateMainLine(newMobiles) {
        if(newMobiles.length == 0) {
            return newMobiles.map(mobile => {
                return this.generateMobile(null, mobile);
            });
        }
        let maxSpeedFtth = this.getMaxFtthSpeed();
        if(maxSpeedFtth == '0' || (this.customerHasPackage() == false && this.allRates.PARAMS.FTTH_ACTIVE.includes(maxSpeedFtth) == false)) {
            //No hay fibra seleccionada o contratada
            return newMobiles.map(mobile => {
                return this.generateMobile(null, mobile);
            });
        }

        //let isOtherBrand = this.getSimyoOrderService().getIsPortabilityOtherBrand() !== null && this.getSimyoOrderService().getIsPortabilityOtherBrand() !== undefined;
        //let ratePackage = ['50 GB', '120 GB', '200 GB'];

        //search max price mobile current order
        let mobileMaxPriceCurrentOrder = this.getMobileMaxPriceCurrentOrder(true);
        //current max mobile
        let currentMaxMobile = this.getMaxMobileCustomer();

        /*let validRateMobiles = newMobiles
            .map((mobile, index) => ({ mobile, index }))
            .filter(item =>
                ['50 GB', '120 GB', '200 GB'].includes(item.mobile?.data) &&
                item.mobile?.voice === 'ILIMITADOS' && (item.mobile?.contract_type == "postpaid" || item.mobile?.type_pay== "postpaid")
            )
            .reduce((best, current) =>
                parseInt(current.mobile.data) > parseInt(best.mobile.data) ? current : best,
                { mobile: { data: '0' }, index: -1 }
            );
        */


        //let isValid = false;
        /*if(isOtherBrand) {
            let hasNotValidRate = currentMaxMobile && ratePackage.includes(currentMaxMobile?.rate_info?.data) && currentMaxMobile?.rate_info?.voice !== 'ILIMITADOS';
            if(hasNotValidRate) {
                isValid = true;
            }
            mobileMaxPriceCurrentOrder.mobile = validRateMobiles.mobile ?? currentMaxMobile;
            mobileMaxPriceCurrentOrder.index = validRateMobiles.index
        }*/

        newMobiles = this.changeRate(newMobiles);

        let hasMainLine = false;
        //Inicializar linea principal
        newMobiles = newMobiles.map(mobile => { return {...mobile, is_main_line: false, type_pay: mobile.type_pay ? mobile.type_pay : mobile.contract_type}});
        let allowed50GB = this.allowedRate50GBNormalPrice(true);
        let mobileMaxPrice = newMobiles[mobileMaxPriceCurrentOrder.index];
        //Comprobar precios maximos y cambiar la linea principal si fuese necesario
        //Tenemos max_mobile del cliente y es la linea principal
        if( currentMaxMobile !== null && mobileMaxPriceCurrentOrder.index < 0 ) {
            hasMainLine = true;
        //Tenemos max_mobile del cliente pero la linea principal esta dentro del pedido actual
        } else if (currentMaxMobile !== null && mobileMaxPriceCurrentOrder.index >= 0) {
            let maxPrice = (mobileMaxPriceCurrentOrder.mobile.rate_info.old_price != null && mobileMaxPriceCurrentOrder.mobile.rate_info.old_price != '') ? +mobileMaxPriceCurrentOrder.mobile.rate_info.old_price : +mobileMaxPriceCurrentOrder.mobile.rate_info.price;
            if (maxPrice > +currentMaxMobile.price || (maxPrice == +currentMaxMobile.price && currentMaxMobile.is_additional)) {// || isValid) {
                newMobiles[mobileMaxPriceCurrentOrder.index].is_main_line = mobileMaxPrice.rate_info.available_in.includes(`ftth_${maxSpeedFtth}`) || (allowed50GB && mobileMaxPrice.data == '50 GB' && mobileMaxPrice.voice == 'ILIMITADOS' && JSON.parse(mobileMaxPrice.show_in).special_first_line == false);
            }
            hasMainLine = true;
        //No tenemos max_mobile del cliente y la linea princial esta dentro del pedido
        } else if(mobileMaxPriceCurrentOrder.index >= 0 && mobileMaxPrice) {
            newMobiles[mobileMaxPriceCurrentOrder.index].is_main_line = mobileMaxPrice.rate_info.available_in.includes(`ftth_${maxSpeedFtth}`) || (allowed50GB && mobileMaxPrice.data == '50 GB' && mobileMaxPrice.voice == 'ILIMITADOS' && JSON.parse(mobileMaxPrice.show_in).special_first_line == false);
            hasMainLine = true;
        //Si es cliente y la linea principal esta en el array de moviles
        }else if(this.getNotCustomer() !== null && newMobiles?.is_main_line){
            hasMainLine = true;
        //No tenemos max_mobile y no tenemos linea principal identificada y estamos evaluado si es la princial.
        }else if(currentMaxMobile == null && newMobiles.length == 1 && newMobiles[0]?.rate_info?.product_code == mobileMaxPriceCurrentOrder?.mobile?.rate_info?.product_code && mobileMaxPriceCurrentOrder?.mobile?.is_main_line){
            hasMainLine = true;
        }



        //Reajustar tarifas con el matrix para hacer cambios de adicionales <-> normal
        newMobiles = newMobiles.map((mobile) => {
            let rates = mobile?.brand == brandPortability.digi ? this.allRates.RATES_BY_BRAND?.digi : this.allRates.RATES;

            let found = null;
            if(((mobile.is_main_line && mobile.rate_ids.refered != '')
                || (currentMaxMobile == null /*&& newMobiles.length == 1*/ && mobile.is_additional && mobile.rate_ids.refered != '' && mobile.is_main_line == true
                || (!hasMainLine && mobile.rate_ids.refered != ''))
            )) {
                //cambiar la tarifa por la no reducida
                found = rates.MOBILE.find(rateMobile => rateMobile.rate_ids.postpaid == mobile.rate_ids.refered
                    || rateMobile.rate_ids.prepaid == mobile.rate_ids.refered)
            }
            //Si no tenemos linea principal no cambiamos las normales a adicionales
            if(hasMainLine
                && mobile.is_main_line == false
                && mobile.rate_ids.additional != ''
                && (mobile.contract_type === mobileContractType.postpaid
                    || mobile.type_pay === mobileContractType.postpaid)) {
                //cambiar la tarifa a la reducida
                found = rates.ADDITIONALS.find(rateMobile => rateMobile.rate_ids.postpaid == mobile.rate_ids.additional
                    || rateMobile.rate_ids.prepaid == mobile.rate_ids.additional)
            }

            return this.generateMobile(found, mobile);
        });

        return newMobiles;
    }

    getMaxFtthSpeed() {
        if(!this.rateFtth && !this.customerInfo) {
            return '0';
        }
        let speedOrder = this.rateFtth?.rate_info ? this.rateFtth.rate_info?.speed : '0';
        let maxSpeedCurrent = this.customerInfo?.max_broadband ? this.customerInfo.max_broadband.speed : '0'
        if(speedOrder == '1' || maxSpeedCurrent == '1') return '1';
        return +maxSpeedCurrent > +speedOrder ? maxSpeedCurrent : speedOrder;
    }

    getMainLine() {
        let mainLine = null;
        if(this.rateMobiles !== null && this.rateMobiles.length > 0) {
            mainLine = this.rateMobiles.find(x=> x.is_main_line) ?? null;
        }
        if(mainLine == null) {
            if(this.getCustomer() !== null){
                let maxMobile = this.getMaxMobileCustomer();
                let maxSpeed = this.getMaxFtthSpeed();
                mainLine = maxMobile?.rate_info?.available_in.includes(`ftth_${maxSpeed}`) || this.getCustomer()?.has_package || this.typeOrder.value == orderType.BROADBAND && maxSpeed == '0' && maxMobile != null ? maxMobile : null
            }

            if(this.typeOrder.value !== orderType.BROADBAND && (this.getNotCustomer()?.zip_code != null || this.getCustomer()?.max_mobile == null) && (this.rateMobiles == null || this.rateMobiles.length < 1)) {
                return true;
            }

        }

        return mainLine;
    }

    getMainLineWithoutSpeed() {
        let mainLine = null;
        if(this.rateMobiles !== null ){
            mainLine = this.rateMobiles.find(x=> x.is_main_line) ?? null;
        }
        if(mainLine == null) {
            let maxMobile = this.getMaxMobileCustomer();
            mainLine = maxMobile ?? null
        }
        return mainLine;
    }

    getTotalMobileLines() {
        let newPostPaidMobiles = this.rateMobiles?.filter(x => x.type_pay === mobileContractType.postpaid);
        let countNewPospaidMobiles = newPostPaidMobiles ? newPostPaidMobiles.length : 0
        let max_mobile = this.customerInfo?.max_mobile;

        return countNewPospaidMobiles + (max_mobile != null ? 1 : 0);
    }

    getIndexMainLine() {
        return this.rateMobiles.findIndex(x => x.is_main_line);
    }

    generateMobile(found, mobile) {
        let rateInfo = this.simyoGlobals.findByKeyInMobile(mobile, 'rate_info');
        if(found) {
            rateInfo = this.simyoGlobals.findByKeyInMobile(found, 'rate_info');
        }
        if(rateInfo == null) {
            return mobile;
        }
        let isAdditional = found ? found.is_additional : mobile.is_additional;
         if(this.getSimyoOrderService().getIsPortabilityOtherBrand() != null && rateInfo?.product_code == "410225"){
            isAdditional = true;
            mobile.is_additional = true;
            if(found) {
                found.is_additional = true;
            }
            
        }
        let totalWithoutDiscount = isAdditional ? rateInfo.old_price : rateInfo.real_price;
        let discount = totalWithoutDiscount - rateInfo.real_price;

        let addFields = {
            is_main_line: mobile.is_main_line ?? false,
            type_pay:mobile.type_pay ? mobile.type_pay : mobile.contract_type,
            discount,
            total_without_discount: +totalWithoutDiscount,
            total_line: this.simyoGlobals.priceMobileMonth(found ? found : mobile),
            recharge: mobile.type_pay === mobileContractType.prepaid ? this.rateService.getRechargePrice(this.simyoGlobals.getMobilePrice(found ? found : mobile)) : null
        }

        if(!found) {
            return {
                ...mobile,
                ...addFields
            };
        }

        return {
            ...mobile,
            ...found,
            ...addFields
        };
    }

    searchMainLineInMatrix(mainLine, forceDigi = false) {
        if(mainLine == null || mainLine == true) {
            return null;
        }
        if(this.typeOrder.value == orderType.BROADBAND) {
            return mainLine;
        }



        let rates = mainLine?.brand == 'digi' || forceDigi ? this.allRates?.RATES_BY_BRAND?.digi : this.allRates?.RATES;
        let rateInMatrix = rates?.MOBILE?.find(rate => rate.rate_info?.product_code == mainLine?.rate_info?.product_code || rate.rate_info?.product_code == mainLine?.rate_info?.product_code_refered);
        if(rateInMatrix != null) {
            return rateInMatrix;
        }

        return mainLine;
    }

    getMaxBroadbandRate() {
        if(!this.rateFtth && !this.customerInfo) {
            return null;
        }
        let rate = null;
        let speedOrder = this.rateFtth?.rate_info ? this.rateFtth.rate_info?.speed : '0';
        let maxSpeedCurrent = this.customerInfo?.max_broadband ? this.customerInfo.max_broadband.speed : '0'
        if(maxSpeedCurrent == '1') rate = this.customerInfo?.max_broadband;
        if(speedOrder == '1') rate = this.rateFtth?.rate_info;
        rate = +maxSpeedCurrent > +speedOrder ? this.customerInfo?.max_broadband : this.rateFtth?.rate_info;

        if(rate.hasOwnProperty('type_normal') == false || rate.hasOwnProperty('type_discount') == false) {
            let rates =  this.rateService.determineRates(this.allRates);
            let rateMatrix = rates.FTTH_NEW.find(r => r.type_discount.product_code == rate.rate_info.product_code || r.type_normal.product_code == rate.rate_info.product_code);
            if(rateMatrix != null) {
                rate.type_normal = rateMatrix.type_normal;
                rate.type_discount = rateMatrix.type_discount;
            }
        }

        return rate;
    }

    allowedRate50GBNormalPrice(onlyCustomer = false) {
        let mainLine = onlyCustomer ? this.getMaxMobileCustomer() : this.getMainLineWithoutSpeed();
        if(mainLine == null || mainLine.price > 7 || mainLine.total_line > 7 || this.customerHasPackage() == false) {
            return false;
        }
        return true;
    }

    private getSimyoOrderService(): SimyoOrderService {
        if (!this.simyoOrderService) {
            this.simyoOrderService = this.injector.get(SimyoOrderService);
        }
        return this.simyoOrderService;
    }


    getCustomerData() {
        return this.getDataFromCustomer().pipe(
            concatMap(data =>
            data != null
                ? of(data)
                : this.getDataFromNotCustomer()
            ),
            tap(data => {
            this.customerData = data;
            }),
            defaultIfEmpty(null)
        );
    }

    setSelectedOperator(data) {
        this.selectedOperator.next(data);
    }

    getSelectedOperator() {
        return this.selectedOperator.asObservable();
    }

    changeRate(newMobiles) {
        let customer = this.getCustomer();
        let isNewCustomer = customer === null;

        let mobilesPostpaidCustomer = customer?.mobiles?.filter((mobile) => mobile?.contract_type === "postpaid") || [];


        if ((isNewCustomer || mobilesPostpaidCustomer.length < 1) && newMobiles.length > 0) {
            let mobilesPostpaid = newMobiles
                .map((mobile, index) => ({ mobile, index }))
                .filter(({ mobile }) => mobile.contract_type === "postpaid" || mobile.type_pay === "postpaid");

            if (!mobilesPostpaid.length) return newMobiles;

            let { mobile, index } = mobilesPostpaid[0]; // Primera línea postpago

            let showIn = mobile?.show_in ? JSON.parse(mobile.show_in) : null;
            let targetRateId: string | null = null;

            // Obtener precio de la primera línea
            let firstLinePrice = parseFloat(mobile.rate_info?.price || "0");

            // Ver si hay otra línea postpago con precio mayor
            let hasHigherPricedLine = mobilesPostpaid
                .slice(1) // omitimos la primera
                .some(({ mobile }) => parseFloat(mobile.rate_info?.price || "0") > firstLinePrice);

            let searchArray;
            // Solo cambiar si es especial y hay otra línea más cara
            if ( showIn != null  && showIn.special_first_line && hasHigherPricedLine ) {
                if ((mobile.data === '50 GB' || mobile.data === '120 GB') && !this.shouldShowSpecialFirstLineRates(index)) {
                    targetRateId = mobile.rate_ids.special_first_line_refered;
                    searchArray = mobile.voice == '120 MIN' ? 'MOBILE' : 'ADDITIONALS';
                    this.isChangeRate = true;
                }
            } else {
                let isOnlyLine = mobilesPostpaid.length <= 1;
                if ( showIn != null  && (mobile.data === '100 GB' || mobile.data === '150 GB') && isOnlyLine && this.isChangeRate && (this.customerInfo != null ? this.customerInfo?.num_subscriptions < 3 : true)) {
                    targetRateId = mobile.rate_ids.special_first_line == '' ? mobile.rate_ids.special_first_line_normal : mobile.rate_ids.special_first_line ;
                    searchArray = 'MOBILE';
                    this.setchangeRateCart(false);
                    this.isChangeRate = false;

                }
            }

            if (!targetRateId) return newMobiles;

            let newRate;
            if(this.getSimyoOrderService().getIsPortabilityOtherBrand() != null){
                newRate = this.allRates.RATES_BY_BRAND.digi[searchArray]?.find(
                    rate => rate.rate_ids.postpaid === targetRateId
                );
            }else {
                newRate = this.allRates.RATES[searchArray]?.find(
                    rate => rate.rate_ids.postpaid === targetRateId
                );
            }


            if (newRate) {
                let updatedMobiles = [...newMobiles];
                updatedMobiles[index] = { 
                    ...newRate,
                    terminal: mobile.terminal
                };
                return updatedMobiles;
            }
        }

        return newMobiles;
    }

    public getchangeRateCart() {
        return this.changeRateCart;
    }

    public setchangeRateCart(changeRateCart) {
        this.changeRateCart = changeRateCart;
    }
        
    public setOptionSelectedModalPorta(isPortaSelected: boolean) {
        this.isPortaOperationSelectedInModal = isPortaSelected;
    }

    public getOptionSelectedModalPorta() {
        return this.isPortaOperationSelectedInModal;
    }

   
    public calculatePriceWithBono(bonos, priceRate){
        if (!bonos || bonos.length === 0) {
            return parseFloat(priceRate);
        }

        let totalBono = bonos
            .filter(b => b.unified_price === 'broadband')
            .reduce((sum, b) => sum + Number(b.price || 0), 0);

        return parseFloat(priceRate) + totalBono;
    }


    public getIsNewProcessing() {
        return this.isNewProcessing;
    }

    public setIsNewProcessing(isNewProcessing) {
        this.isNewProcessing = isNewProcessing;
    }


    private shouldShowSpecialFirstLineRates(index = 0): boolean {
        if (this.typeOrder.value !== orderType.CONVERGENT || index != 0 || !this.isNewCustomer()) {
            return false;
        }

        const mobiles = this.getSimyoOrderService().order.mobiles;
        const postpaidMobiles = mobiles.filter(m => m.contract_type === mobileContractType.postpaid);


        if (postpaidMobiles.length === 0) {
            return true;
        }

        const currentMobileIndex = this.simyoStepperService.getCurrentStep() - 1;
        const currentMobile = mobiles[currentMobileIndex] ?? null;


        const firstPostpaidIndex = mobiles.findIndex(m => m.contract_type === mobileContractType.postpaid);
        const isFirstPostpaid = firstPostpaidIndex === currentMobileIndex;
      
        if (currentMobile == null || !isFirstPostpaid) {
            return false;
        }

        const isOnlyPostpaidLine = postpaidMobiles.length <= 1;
        if (isOnlyPostpaidLine) {
            return true;
        }

        const otherMobiles = mobiles.filter((_, i) => i !== currentMobileIndex);
        const mobileWithMaxPrice = otherMobiles.slice(1).reduce((max, current) => {
            const currentPrice = parseInt(current.rate?.rate_info?.real_price);
            const maxPrice = parseInt(max.rate?.rate_info?.real_price);
            if (currentPrice == null) return max;
            if (maxPrice == null) return current;
            return currentPrice > maxPrice ? current : max;
        }, mobiles[0]);
        return Math.floor(mobileWithMaxPrice?.price) < Math.floor(currentMobile?.price);
    }

    public resolvePostpaidRates(rates: any[], index = 0): any[] {
        const showSpecial = this.shouldShowSpecialFirstLineRates(index);

        const normalRates = rates.filter(rate => {
            const showIn = rate?.show_in ? JSON.parse(rate.show_in) : {};
            return showIn.special_first_line !== true;
        });

        if (!showSpecial || this.getSimyoOrderService().getIsPortabilityOtherBrand() != null) {
            return normalRates;
        }

        const byPostpaidId = new Map(
            normalRates.map(rate => [String(rate.rate_ids.additional) || String(rate.rate_ids.postpaid), rate])
        );

        rates.forEach(rate => {
            const showIn = rate?.show_in ? JSON.parse(rate.show_in) : {};
            const special_refered_rate_id = rate?.special_refered_rate_id;
            if (showIn.special_first_line === true && special_refered_rate_id) {
                const key = String(special_refered_rate_id);
                if (byPostpaidId.has(key)) {
                    byPostpaidId.set(key, rate);
                }
            }
        });

        return Array.from(byPostpaidId.values());
    }
    
    isNewCustomer() {
        let customer = this.getCustomer();

        if (customer == null) {
            return true;
        }

        let mobilesPostpaidCustomer = customer?.mobiles?.filter(mobile => mobile.contract_type === "postpaid");

        return mobilesPostpaidCustomer?.length < 1 && customer?.broadbands?.length < 1;

    }

    isShowSimyoTVBono(): boolean {
        const customer = this.getCustomer();
        const isMobileOnly = this.typeOrder.value === orderType.MOBILE;
        const isFirstStep = this.shoppingCartService.getStepper().selectedIndex === 0;
    
        if (!customer && !isMobileOnly && isFirstStep) return true;
    
        if (customer) {
            const hasSimyoTV = customer.bonuses?.some(b => this.isSimyoTVBono(b));
            if (hasSimyoTV) return false;
    
            const hasBroadband = customer.broadbands?.length > 0;
    
            // Tiene fibra -> SI (solo en primer paso)
            if (hasBroadband) return isFirstStep;
    
            // No tiene fibra y no es solo móvil -> SI (solo en primer paso)
            if (!hasBroadband && !isMobileOnly) return isFirstStep;
        }
    
        return false;
    }

    isSimyoTVBono(bono: any): boolean {
        if (!bono) return false;
        return  bono.unified_price == null && bono.name == 'simyo_TV';
    }


    getIsSpecial300Reduced() {
        const orderService = this.getSimyoOrderService();
        const customer = this.getCustomer();
    
        if ((orderService.getIsPortabilityOtherBrand() && orderService.getCpOtherBrand() === '12') || !customer) {
            return false;
        }
       
        const hasPackage = customer.has_package;
        const orderTypeValue = this.typeOrder.value;
    
        if (hasPackage === false) {
            if (orderTypeValue === orderType.BROADBAND) {
                return false;
            }
            
            if (orderTypeValue === orderType.CONVERGENT) {
                const totalFtth = customer.num_ftth?.total_ftth ?? 0;
                const totalFtthDiscount = customer.num_ftth?.total_ftth_discount ?? 0;
                let isBroadbandNotPackage = customer.max_broadband != null && totalFtth == 0 && totalFtthDiscount < 3;
            
                return isBroadbandNotPackage || (totalFtth > 0 && totalFtthDiscount < 3);
            }
        }
    
        if (hasPackage === true) {
            const totalFtthDiscount = customer.num_ftth?.total_ftth_discount ?? 0;
            return totalFtthDiscount < 3;
        }
    
        return false;
    }
}
